
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"vuesax/twotone/bag-2","xmlns":"http://www.w3.org/2000/svg","width":"22","height":"22","viewBox":"0 0 22 22"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#697485"}},[_c('path',{attrs:{"d":"M15.158 7.983a.693.693 0 01-.693-.693V6.013a3.478 3.478 0 00-1.139-2.57 3.427 3.427 0 00-2.666-.877 3.726 3.726 0 00-3.125 3.625v.9a.693.693 0 01-.693.693.693.693 0 01-.693-.697v-.9a5.108 5.108 0 014.38-5 4.851 4.851 0 015.322 4.826v1.278a.693.693 0 01-.693.692z","opacity":".4"}}),_c('path',{attrs:{"data-name":"Vector","d":"M13.744 20.845H8.259a5.788 5.788 0 01-4.037-1.151 4.19 4.19 0 01-1.176-2.76l-.687-5.538v-.01a4.31 4.31 0 01.813-3.487c.82-.925 2.187-1.375 4.169-1.375h7.318c1.985 0 3.349.45 4.169 1.375a4.31 4.31 0 01.812 3.487v.01l-.686 5.538a4.19 4.19 0 01-1.176 2.76 5.788 5.788 0 01-4.034 1.151zM3.723 11.229l.685 5.539v.012a2.76 2.76 0 00.74 1.894 4.591 4.591 0 003.108.789h5.488a4.591 4.591 0 003.108-.789 2.76 2.76 0 00.738-1.891v-.015l.685-5.539a3 3 0 00-.471-2.405c-.535-.607-1.594-.914-3.145-.914H7.341c-1.551 0-2.61.307-3.147.914a3 3 0 00-.471 2.405z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M14.21 11.924h-.009a.924.924 0 110-1.848h.009a.924.924 0 010 1.848zM7.797 11.924h-.009a.924.924 0 110-1.848h.009a.924.924 0 010 1.848z","opacity":".4"}})])])
          )
        }
      }
    